import React from "react";
import {
  Search,
  Ban,
  Zap,
  QrCode,
  Building2,
  Users2,
  Eye,
  Accessibility,
} from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Search, Ban, Zap, QrCode, Building2, Users2, Eye, Accessibility];

export default function Benefits() {
  const { t } = useLang();
  return (
    <section className="section-y bg-brand-cloud" data-testid="benefits-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="overline">{t.benefits.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.benefits.title}
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {t.benefits.items.map((b, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                className="card-soft card-soft-hover p-6 md:p-7 h-full flex flex-col"
                data-testid={`benefit-${i}`}
              >
                <span className="grid place-items-center h-10 w-10 rounded-xl bg-white border border-brand-mist text-brand-ink">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 text-base md:text-lg font-medium text-brand-ink">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-brand-graphite leading-relaxed">{b.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
